import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { toast } from '../../utils/alert';

export default function ImpersonationBanner() {
  const { isImpersonating, impersonator, stopImpersonation } = useAuth();

  if (!isImpersonating) return null;

  const handleStop = async () => {
    try {
      await stopImpersonation();
      toast('success', '', 'Back to admin account');
    } catch {
      toast('error', '', 'Failed to stop impersonation');
    }
  };

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
        color: '#fff',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 13,
        fontWeight: 600,
        zIndex: 9999,
        position: 'relative',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span
          style={{
            background: 'rgba(255,255,255,0.25)',
            padding: '3px 10px',
            borderRadius: 4,
            fontSize: 11,
            textTransform: 'uppercase',
            letterSpacing: 1,
          }}
        >
          Impersonating
        </span>
        <span>
          You are viewing as <strong>{impersonator?.targetName || 'a user'}</strong>
          {impersonator?.name && <> &mdash; Admin: {impersonator.name}</>}
        </span>
      </div>
      <button
        onClick={handleStop}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: '1px solid rgba(255,255,255,0.4)',
          color: '#fff',
          padding: '6px 16px',
          borderRadius: 6,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          fontSize: 12,
          fontWeight: 600,
        }}
      >
        <FiArrowLeft size={14} />
        Back to Admin
      </button>
    </div>
  );
}
